const Seal = () => import(/* webpackChunkName: "seal" */ './QuickSeal');
const Index = () => import(/* webpackChunkName: "manager" */ './Index');
const SealManager = () => import(/* webpackChunkName: "manager" */ './SealQuickManager');
export default {
    routes: [
        {
            path: '/seal/quickseal',
            name: 'seal_quick',
            component: Seal
        },
        {
            path: '/seal/index',
            name: 'seal_index',
            component: Index
        },
        {
            path: '/seal/sealquickmanager',
            name: 'seal_manager',
            component: SealManager
        },
    ]
}
